<template>
  <section id="infoCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      :module="moduleType"
      :queues="queueList"
      @dialog:change="eventdialog"
    ></RangeDateDialog>

    <v-card class="shadow-1 mt-5">
      <v-tabs
        v-model="tab"
        dark
        background-color="secondary lighten-1"
        hide-slider
        grow
      >
        <v-tab
          v-for="(item, index) in tabHeaders"
          :key="index"
          @click="getInfo(index)"
        >
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabHeaders" :key="item">
          <v-card flat>
            <v-container class="px-md-7" fluid v-if="customSearchInfo">
              <v-row dense justify="space-between">
                <v-col cols="12" md="auto">
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Tipo</span>
                    {{
                      customSearchInfo.call == null
                        ? "Todas"
                        : customSearchInfo.call === 1
                        ? "Salientes"
                        : "Entrantes"
                    }}
                  </span>
                </v-col>

                <v-col cols="12" md="auto">
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Desde</span>
                    {{ customSearchInfo.start }}
                  </span>
                  <span class="blue-grey--text text--darken-3">
                    <span class="caption grey--text">Hasta</span>
                    {{ customSearchInfo.end }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
            <v-divider v-if="customSearchInfo"></v-divider>

            <!-- Tabla -->
            <v-container>
              <v-skeleton-loader v-if="isLoading" type="table">
              </v-skeleton-loader>

              <v-row v-else dense justify="end">
                <v-col cols="12">
                  <vuescroll
                    :ops="{
                      bar: {
                        background: '#bacfcec0',
                        keepShow: true,
                      },
                    }"
                  >
                    <v-data-table
                      :headers="tableHeaders"
                      :items="tableItems"
                      class="elevation-0"
                      :items-per-page="15"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:[`item.pause`]="{ item }">
                        <span style="text-transform: capitalize">
                          {{ item.pause.name | capitalize }}
                        </span>
                      </template>

                      <template v-slot:[`item.time`]="{ item }">
                        <span>
                          {{ item.pause.time }}
                        </span>
                      </template>

                      <template
                        v-slot:[`item.timeOut`]="{
                          item,
                        }"
                      >
                        <span>{{
                          getTimeout(item.created_at, item.updated_at)
                        }}</span>
                      </template>
                      <template
                        v-slot:[`item.dateStart`]="{
                          item,
                        }"
                      >
                        <span>{{ item.created_at }}</span>
                      </template>
                      <template
                        v-slot:[`item.dateEnd`]="{
                          item,
                        }"
                      >
                        <span>{{ item.updated_at }}</span>
                      </template>
                    </v-data-table>
                  </vuescroll>
                </v-col>

                <v-col cols="auto">
                  <v-pagination
                    circle
                    :total-visible="7"
                    color="primary"
                    v-model="currentPage"
                    :length="totalPages"
                    @input="handlePageChange"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
/**
 * @author Abraham Correa
 */
import vuescroll from "vuescroll";
import axios from "axios";
import moment from "moment";

import RangeDateDialog from "../../DatePickers/DateRangePicker";

export default {
  name: "ActivityOverview",
  inject: ["theme"],
  components: {
    RangeDateDialog,
    vuescroll,
  },
  props: {
    type: {
      type: String,
    },
    moduleType: {
      type: String,
    },
  },
  data() {
    return {
      request: "",
      infoUrl: `${process.env.VUE_APP_ROOTAPI}`,
      accessToken: localStorage.getItem("token"),
      rangeDialogActive: false,
      tab: null,
      tabHeaders: ["Diario", "Personalizado"],
      innerTab: null,
      isLoading: false,
      search: "",
      customSearchInfo: null,
      axiosInstance: null,
      dataUrl: ["pauses_made", "pauses_made_custom"],
      customParameters: {},
      tableHeaders: [
        {
          text: "Nombre de la pausa",
          value: "pause",
          width: "30%",
        },
        {
          text: "Duracion",
          value: "time",
          width: "15%",
        },
        {
          text: "Tiempo transcurrido",
          value: "timeOut",
          width: "15%",
        },
        {
          text: "Fecha de inicio",
          value: "dateStart",
          width: "20%",
        },
        {
          text: "Fecha Fin",
          value: "dateEnd",
          width: "20%",
        },
      ],
      tableItems: [],
      currentPage: 1,
      totalPages: null,
      queueList: [],
      options: {},
      render: false,
      webURL: null,
      headers: [],
      // Table Data
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.axiosInstance = axios.create({
      baseURL: this.infoUrl,
      headers: {
        Authorization: `Bearer ${this.accessToken}`,
      },
    });
    this.getInfo(0);
  },

  methods: {
    /**
     * Busca los datos
     * @param {Number} index - Indice de la Tab
     */
    async getInfo(index) {
      this.isLoading = true;
      if (index === 1) {
        this.rangeDialogActive = true;
      } else {
        const request = this.dataUrl[0];
        try {
          const { data } = await this.axiosInstance.get(
            `/agents/sumary/${request}`
          );
          this.currentPage = data.currentPage;
          this.totalPages = data.last_page;
          this.tableItems = data.data.map((el, index) => ({
            ...el,
            _id: el.id,
            id: index,
          }));
          this.path = data.path;
        } catch (errors) {
          if (errors.response.status === 401) {
            this.$snotify.error("Su sesion ha finalizado.", "Error");
            this.$store.dispatch("passport/RESET_AUTH");
            this.$router.push({ name: "login" });
            return;
          }
          console.log(errors);
        }
        this.isLoading = false;
      }
      return;
    },

    /**
     * Cambia la pagina actual
     * @param {string} index - Indice de la tabla mostrada
     * @param {string} table - Nombre de la tabla mostrada
     */
    async handlePageChange(index) {
      this.isLoading = true;
      const request = this.tab === 1 ? this.dataUrl.slice(-1) : this.dataUrl[0];

      const path =
        this.type === "queue"
          ? `/reports/tail_personality_details?page=${index}`
          : `/agents/sumary/${request}?page=${index}`;
      //   const page = this.currentPage[index];

      try {
        const { data } =
          this.tab === 1
            ? await this.axiosInstance.post(path, this.customParameters)
            : await this.axiosInstance.get(
                `/agents/sumary/${request}?page=${index}`
              );
        this.tableItems = data.data.map((el, index) => ({
          ...el,
          _id: el.id,
          id: index,
        }));
      } catch (err) {
        console.log(err);
      }
      this.isLoading = false;
    },

    /**
     * [Obtener estado en español]
     * @param {String} state Estado de la llamada
     */
    getSpanishState(state) {
      if (state == "ANSWERED") {
        return {
          text: "Contestada",
          color: "success",
          icon: "mdi-phone-outline",
        };
      } else {
        return {
          text: "No contestada",
          color: "error",
          icon: "mdi-call-missed",
        };
      }
    },

    getTimeout(start, end) {
      const dateStart = moment(start);
      const dateEnd = moment(end);
      const diff = dateEnd.diff(dateStart);
      return moment.utc(diff).format("HH:mm:ss");
    },

    async eventdialog(data, parameters) {
      this.rangeDialogActive = false;
      const url = this.dataUrl.slice(-1);
      const payload = parameters;
      if (data !== "cerrar") {
        this.isLoading = true;
        try {
          const { data } = await this.axiosInstance.post(
            `/agents/sumary/${url}`,
            payload
          );
          // console.log("data", data);
          this.tableItems = data.data;
          this.totalPages = data.last_page;
          this.currentPage = data.current_page;
          this.customParameters = payload;
        } catch (err) {
          this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
          // console.error(err);
          this.tab = 0;
          this.getInfo(0);
        }
        this.isLoading = false;
      } else {
        this.tab = 0;
        this.getInfo(0);
      }
      return;
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
}

audio {
  height: 35px !important;
}
</style>
